import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "entity-chat-ui-badge",
  {
    variants: {
      variant: {
        default: "entity-chat-ui-badge-default",
        secondary: "entity-chat-ui-badge-secondary",
        destructive: "entity-chat-ui-badge-destructive",
        outline: "entity-chat-ui-badge-outline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }

